"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsSdisMapContextInfo", function () {
    return {
        restrict: "E",
        require: "^obsSdisManager",
        scope: true,
        replace: true,
        template: require("./obsSdisMapContextInfo.html")
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/sdis/obsSdisMapContextInfo.js